if (!customElements.get('fs-vip-checkout')) {
  customElements.define('fs-vip-checkout', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      this.status = this.querySelector('[role="status"]');
      this.button.disabled = false;
      this.onclick = event => {
        if (!event.target.closest('button')) return;
        event.preventDefault();
        this.openCheckout();
      };
    }
    async openCheckout() {
      if (this.busy) return;
      this.busy = true;
      this.button.disabled = true;
      this.status.hidden = false;
      this.status.textContent = this.dataset.loading;
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 20000);
      try {
        const merchandiseId = `gid://shopify/ProductVariant/${this.dataset.variant}`;
        const attributes = [{ key: 'Reservation currency', value: 'CAD' }];
        if (this.dataset.secondWave === 'true') attributes.push({ key: 'Reservation cohort', value: 'Second Wave VIP' });
        const response = await fetch('/api/2026-10/graphql.json', {
          method: 'POST',
          credentials: 'omit',
          headers: { 'Content-Type': 'application/json' },
          signal: controller.signal,
          body: JSON.stringify({
            query: 'mutation VipCart($input: CartInput!) { cartCreate(input: $input) { cart { checkoutUrl totalQuantity cost { totalAmount { amount currencyCode } } lines(first:2) { nodes { quantity merchandise { ... on ProductVariant { id requiresShipping } } } } } userErrors { field message } } }',
            variables: { input: { buyerIdentity: { countryCode: 'CA' }, lines: [{ merchandiseId, quantity: 1, attributes }], attributes: [{ key: 'VIP checkout', value: 'CAD 1 isolated' }] } }
          })
        });
        if (!response.ok) throw new Error('Checkout request failed');
        const result = await response.json();
        const created = result.data?.cartCreate;
        if (result.errors?.length || !created || created.userErrors?.length) throw new Error('Checkout unavailable');
        const cart = created.cart;
        const total = cart?.cost?.totalAmount;
        const lines = cart?.lines?.nodes;
        if (cart?.totalQuantity !== 1 || total?.currencyCode !== 'CAD' || Number(total.amount) !== 1 || lines?.length !== 1 || lines[0].quantity !== 1 || lines[0].merchandise.id !== merchandiseId || lines[0].merchandise.requiresShipping !== false) throw new Error('Reservation amount could not be confirmed');
        const url = new URL(cart.checkoutUrl);
        if (url.protocol !== 'https:' || ![location.hostname, this.dataset.shopDomain].includes(url.hostname)) throw new Error('Unexpected checkout destination');
        const preview = new URL(location.href).searchParams.get('preview_theme_id');
        if (preview && preview === this.dataset.theme) url.searchParams.set('preview_theme_id', preview);
        this.status.textContent = this.dataset.loading;
        location.assign(url.href);
      } catch (error) {
        this.status.textContent = this.dataset.error;
        this.button.disabled = false;
        this.busy = false;
      } finally {
        clearTimeout(timeout);
      }
    }
  });
}
